import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";

// Material-UI Icon
import AddIcon from "@material-ui/icons/Add";

// Custom Component
import Legend from "../../../Legend/Legend";
import FileDropzone from "../../../FileDropzone/WorkflowFileDropzone";
import RFIResponseFileZoneContent from ".././RFIResponseFileZoneContent";

import { ckEditorToolbar } from "../../../../global/ckEditor";

// Custom Style
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";
const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));
const RFIResponse = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const propertySeqRedux = useSelector((state) => state.propertySeqRedux);

  const {
    postResponseConfirmAction,
    saveResponsetoDraftAction,
    rfi_seq,
    responseFileUploadAction,
    removeResponseFileConfirmAction,
    viewFileAction,
    openFileManagerDialog,
    submissionResponseValue,
    setSubmissionResponseValue,
    responsevalidate,
    responsevalidationErrors,
    presetResponseFiles,
  } = props;
  const submissionRFIResponseRedux = useSelector(
    (state) => state.submissionRFIResponseRedux
  );

  // const [submissionResponseValue, setSubmissionResponseValue] = useState({});

  const handleRadioChange = (event) => {
    const data = { ...submissionResponseValue };
    data.type = event.target.value;

    setSubmissionResponseValue({ ...submissionResponseValue, ...data });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, ...data },
    });

    if (event.target.value !== "givecomment") {
      submissionResponseValue.content = "";
      submissionResponseValue.messages.attachments = [];
    }
  };

  // Handle Form Input
  const ckeditorHandleChange = (name) => (event, editor) => {
    const inputData = editor.getData();
    const data = { ...submissionResponseValue };
    data.response = inputData;
    setSubmissionResponseValue({ ...submissionResponseValue, ...data });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, ...data },
    });
  };

  const handleResponseInputChange = (name, validateOnChange) => (event) => {
    const data = { ...submissionResponseValue };
    setSubmissionResponseValue({
      ...submissionResponseValue,
      [name]: event.target.value,
    });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, ...data },
    });
    if (validateOnChange) {
      responsevalidate({
        ...submissionResponseValue,
        [name]: event.target.value,
      });
    }
  };

  // CKEditor Config
  const editorConfiguration = {
    toolbar: ckEditorToolbar,
  };

  useEffect(() => {
    let data = { ...submissionResponseValue };

    data.messages.dms_property_seqs = propertySeqRedux;

    // if (presetSubject !== null) {
    //   data.circ_subject = presetSubject;
    //   setCirculationSubject(presetSubject);
    // }

    if (presetResponseFiles !== null) {
      data.messages.attachments.push(...presetResponseFiles);
    }

    setSubmissionResponseValue({ ...submissionResponseValue, ...data });
    dispatch({
      type: "ADD_RFI_RESPONSE_SUBMISSION_VALUE",
      data: { ...submissionResponseValue, data },
    });
  }, [presetResponseFiles]);

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Typography variant="subtitle1" className={classes.headerText}>
            Response
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle1" className={classes.subHeaderText}>
            Create Main Contractor Response
          </Typography>
          <FormGroup row={true}>
            <RadioGroup
              aria-label="response"
              name="response"
              value={submissionResponseValue.type || ""}
              onChange={handleRadioChange}
            >
              <FormControlLabel
                value="noted"
                control={<Radio />}
                label="Noted and not my group to reply"
              />
              <FormControlLabel
                value="nocomment"
                control={<Radio />}
                label="No advise comment"
              />
              <FormControlLabel
                value="givecomment"
                control={<Radio />}
                label="Give comment"
              />
            </RadioGroup>
          </FormGroup>
          {submissionResponseValue.type === "givecomment" && (
            <>
              <Grid item xs={12}>
                <div className={classes.fileUploadBtnArea}>
                  <Legend id="attachment" label="ATTACHMENT">
                    <Box className={classes.addFileBtnArea}>
                      <FileDropzone
                        key={"rfi_attachment"}
                        title={""}
                        fileType={"rfi_attachment"}
                        disabled={false}
                        fileUploadAction={responseFileUploadAction}
                        fileRemoveAction={removeResponseFileConfirmAction}
                        viewFileAction={viewFileAction}
                        DropzoneContent={RFIResponseFileZoneContent}
                        openFileManagerDialog={openFileManagerDialog}
                      />
                    </Box>
                  </Legend>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Legend id="content" label="CONTENT">
                  <CKEditor
                    editor={ClassicEditor}
                    data={submissionResponseValue.content || ""}
                    name={"response"}
                    onChange={ckeditorHandleChange("response")}
                    config={editorConfiguration}
                  />
                </Legend>
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id="from"
              label="From"
              margin="normal"
              variant="outlined"
              name="from"
              type="text"
              size="small"
              value={submissionResponseValue.from || ""}
              onChange={handleResponseInputChange(
                "from",
                responsevalidationErrors.from &&
                  responsevalidationErrors.from !== ""
                  ? true
                  : false
              )}
              error={
                responsevalidationErrors.from &&
                responsevalidationErrors.from !== ""
                  ? true
                  : false
              }
              helperText={responsevalidationErrors.from}
            ></TextField>
          </Grid>
          <Grid item xs={12}>
            <TextField
              required
              className={classes.textField}
              fullWidth={true}
              id="companyName"
              label="Company Name"
              margin="normal"
              variant="outlined"
              name="companyName"
              type="text"
              size="small"
              value={submissionResponseValue.companyName || ""}
              onChange={handleResponseInputChange(
                "companyName",
                responsevalidationErrors.companyName &&
                  responsevalidationErrors.companyName !== ""
                  ? true
                  : false
              )}
              error={
                responsevalidationErrors.companyName &&
                responsevalidationErrors.companyName !== ""
                  ? true
                  : false
              }
              helperText={responsevalidationErrors.companyName}
            ></TextField>
          </Grid>
          <TextField
            id="response_date"
            style={{ width: "100%" }}
            defaultValue={moment(new Date().toISOString().slice(0, 10)).format(
              "DD/MM/YYYY"
            )}
            label={"Date"}
            InputProps={{
              readOnly: true,
            }}
            variant="outlined"
          />
          <Grid container spacing={1}>
            <div className={classes.rfibtnGroup}>
              <Button
                variant="contained"
                color="primary"
                className={classes.formBtn}
                onClick={() => {
                  saveResponsetoDraftAction(rfi_seq, 0);
                }}
              >
                Save Only
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.formBtn}
                onClick={() => {
                  postResponseConfirmAction(rfi_seq, 0);
                }}
              >
                Send
              </Button>
            </div>
          </Grid>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default RFIResponse;
